var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.82,5H9.44A1.7,1.7,0,0,0,7.75,6.7V33.3A1.7,1.7,0,0,0,9.44,35H29.82a1.7,1.7,0,0,0,1.7-1.7V6.7A1.7,1.7,0,0,0,29.82,5ZM9.44,6.13H29.82a.58.58,0,0,1,.57.57v7.47H8.88V6.7A.57.57,0,0,1,9.44,6.13Zm21,17.69a.53.53,0,0,0-.12,0H8.88V15.3H30.39Zm-.57,10H9.44a.57.57,0,0,1-.56-.57V24.92H30.27l.12,0v8.4A.58.58,0,0,1,29.82,33.87Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.71,
    cy: 9.53,
    r: 1.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.71,
    cy: 20,
    r: 1.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.71,
    cy: 29.62,
    r: 1.42
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.44,10.09H22.63a.57.57,0,0,0,.57-.56A.58.58,0,0,0,22.63,9H12.44a.57.57,0,0,0-.56.57A.56.56,0,0,0,12.44,10.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.44,20.85H22.63a.57.57,0,1,0,0-1.13H12.44a.57.57,0,0,0,0,1.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.63,29.34H12.44a.57.57,0,0,0,0,1.13H22.63a.57.57,0,1,0,0-1.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.b2ccfe135d4984a82bd8d1ebbd65e08f.svg";
export { ForwardRef as ReactComponent };